import classList from '../utils/classList';
import Component from '../Component';
export default class Avatar extends Component {
  view(vnode) {
    const {
      user,
      ...attrs
    } = vnode.attrs;
    attrs.className = classList('Avatar', attrs.className);
    attrs.loading ??= 'lazy';
    let content = '';

    // If the `title` attribute is set to null or false, we don't want to give the
    // avatar a title. On the other hand, if it hasn't been given at all, we can
    // safely default it to the user's username.
    const hasTitle = attrs.title === 'undefined' || attrs.title;
    if (!hasTitle) delete attrs.title;

    // If a user has been passed, then we will set up an avatar using their
    // uploaded image, or the first letter of their username if they haven't
    // uploaded one.
    if (user) {
      const username = user.displayName() || '?';
      const avatarUrl = user.avatarUrl();
      if (hasTitle) attrs.title = attrs.title || username;
      if (avatarUrl) {
        return m("img", Object.assign({}, attrs, {
          src: avatarUrl,
          alt: ""
        }));
      }
      content = username.charAt(0).toUpperCase();
      attrs.style = !window.testing && {
        '--avatar-bg': user.color()
      };
    }
    return m("span", attrs, content);
  }
}
flarum.reg.add('core', 'common/components/Avatar', Avatar);